import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLocale } from "@/context/LocaleContext";
import featured from "@/data/homeBlogPreview.json";

export function BlogTeaser() {
  const { t } = useLocale();
  if (!featured) return null;
  return (
    <section className="container-shule py-6 md:py-10" aria-labelledby="style-guides-title">
      <div className="rounded-3xl border border-shule-line bg-shule-paper p-5 sm:p-8 grid md:grid-cols-[1fr_1fr] gap-6 items-center">
        <div>
          <p className="eyebrow">{t("Blog")}</p>
          <h2 id="style-guides-title" className="mt-2 font-serif text-3xl sm:text-4xl">{t("Stil Rehberleri")}</h2>
          <p className="mt-3 text-sm leading-relaxed text-shule-mocha">{t("Takı seçimi, aksesuar bakımı ve hediye fikirleri için Shule yazıları.")}</p>
          <Link to="/blog/" className="mt-4 min-h-[44px] inline-flex items-center gap-2 font-semibold text-sm underline underline-offset-4">
            {t("Blogu keşfet")} <ArrowRight aria-hidden="true" className="w-4 h-4" />
          </Link>
        </div>
        <Link to={`/blog/${featured.slug}/`} lang="tr" dir="ltr" className="group flex items-center gap-4 rounded-2xl border border-shule-line bg-white p-3 hover:shadow-md transition-shadow">
          <img src={featured.image} alt="" loading="lazy" width="112" height="112" className="w-24 h-24 sm:w-28 sm:h-28 shrink-0 rounded-xl object-cover" />
          <span className="min-w-0 font-serif text-lg sm:text-xl leading-snug">{featured.title}<ArrowRight aria-hidden="true" className="mt-3 w-4 h-4" /></span>
        </Link>
      </div>
    </section>
  );
}
